'use client';

import { useEffect, useState } from 'react';
import { api } from '@/lib/client';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [expired, setExpired] = useState(false);

  // Read straight off location rather than useSearchParams(), which would force this
  // page into a Suspense boundary for no benefit.
  useEffect(() => {
    setExpired(new URLSearchParams(window.location.search).has('expired'));
  }, []);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      const res = await api.login(username, password);
      if (res.ok) {
        window.location.href = '/dashboard';
      } else {
        const body = await res.json().catch(() => ({}));
        setError(body.error || 'Login failed.');
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-wrap">
      <div className="card login-card">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img className="login-logo" src="/uhaven-logo.svg" alt="uHaven logo" />
        <h1>Staff Console</h1>
        <p className="muted">Sign in to continue</p>
        {expired && (
          <div className="banner banner-warning">
            Your session timed out — sessions last 12 hours. Sign in again to carry on.
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <label htmlFor="username">Username</label>
          <input
            id="username"
            className="input"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <label htmlFor="password">Password</label>
          <input
            id="password"
            className="input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {error && <div className="banner banner-error">{error}</div>}
          <button className="button" type="submit" disabled={submitting}>
            Log in
          </button>
        </form>
      </div>
    </div>
  );
}
